export const castTypeArr = <T>(arr: any[]): T[] => {
    return arr.map((el) => el as T);
};
